import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as BeaconsService from "_services/beacons-service";
import { format, startOfToday } from "date-fns";

const initialState = {
  postStatus: "idle",
  status: "idle",
  error: null,
  submittedWaitTimes: [],
  selectedBeacon: null,
  waitingTimes: null,
  waitingTimesList: [],
  gettingWaitingTimesListStatus: 'idle',

  tab: 1,

  // list filters
  selectBeaconArea: null,
  startDate: null,
  endDate: null,
};

export const getBeaconSubmittedTimes = createAsyncThunk(
  "beacons/getBeaconSubmittedTimes",
  async (params) => {
    return BeaconsService.getBeaconSubmittedTimes(params);
  }
);

// get all bookings
export const getWaitingTimes = createAsyncThunk(
  "beacons/getWaitingTimes",
  async (params, signal) => {
    return BeaconsService.getWaitingTimes(params, signal);
  }
);

export const postMinor = createAsyncThunk(
  "beacons/postMinor",
  async (params, signal) => {
    return BeaconsService.postMinor(params, signal);
  }
);


export const deleteMinor = createAsyncThunk(
  "beacons/deleteMinor",
  async (params, signal) => {
    return BeaconsService.deleteMinor(params, signal);
  }
);

export const getWaitingTimesList = createAsyncThunk(
  "beacons/getWaitingTimesList",
  async (iata) => {
    return BeaconsService.getWaitingTimesList(iata);
  }
);

const arrivalsSlice = createSlice({
  name: "beacons",
  initialState,
  reducers: {
    reset: (state) => initialState,
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSelectedBeacon: (state, action) => {
      console.log('setting beacon...', action.payload)
      state.selectedBeacon = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setBeaconAreaFilter: (state, action) => {
      state.selectBeaconArea = action.payload;
    },
    setTab : (state, action) => {
      state.tab = action.payload;
    }
  },
  extraReducers: {
    [getWaitingTimes.pending]: (state, action) => {
        return {
          ...state,
        status: "loading",
        }
    },
    [getWaitingTimes.fulfilled]: (state, action) => {
      state.waitingTimes = action.payload;
      state.status = 'succeeded';
      state.error = null
    },
    [getWaitingTimes.rejected]: (state, action) => {
      return {
        ...state,
        status: !action.meta.aborted ? "failed" : state.status,
        waitingTimes: !action.meta.aborted ? null : state.waitingTimes,
        error: !action.meta.aborted ? action.error.message : state.error,
      }
    },
    [postMinor.pending]: (state, action) => {
        return {
          ...state,
        postStatus: "loading",
        }
    },
    [postMinor.fulfilled]: (state, action) => {
        return {
          ...state,
          postStatus: 'succeeded',
        }
    },
    [postMinor.rejected]: (state, action) => {
      state.postStatus = 'failed';
      state.error = action.error.message
    },
    
    [deleteMinor.pending]: (state, action) => {
        return {
          ...state,
        postStatus: "loading",
        }
    },
    [deleteMinor.fulfilled]: (state, action) => {
        return {
          ...state,
          postStatus: 'succeeded',
        }
    },
    [deleteMinor.rejected]: (state, action) => {
      return {
        ...state,
        postStatus: !action.meta.aborted ? "failed" : state.postStatus,
        waitingTimes: !action.meta.aborted ? null : state.waitingTimes,
        error: !action.meta.aborted ? action.error.message : state.error,
      }
    },
    [getWaitingTimesList.pending]: (state, action) => {
      state.gettingWaitingTimesListStatus = 'loading'
    },
    [getWaitingTimesList.fulfilled]: (state, action) => {
      state.gettingWaitingTimesListStatus = 'succeeded';
      state.waitingTimesList = action.payload;
    },
    [getWaitingTimesList.rejected]: (state, action) => {
      state.gettingWaitingTimesListStatus = 'failed';
      state.error = action.payload;
    },
    [getBeaconSubmittedTimes.pending]: (state, action) => {
      state.status = 'loading'
    },
    [getBeaconSubmittedTimes.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.submittedWaitTimes = action.payload;
    },
    [getBeaconSubmittedTimes.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});


export const selectWaitingTimes = (state) => {

  function convertSecondsToMinutes(seconds) {
    seconds = Math.round(seconds); // round to nearest whole number
    if (seconds < 60) {
      return seconds + ' seconds';
    } else {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;
      if (remainingSeconds === 0) {
        return minutes + ' minutes';
      } else {
        return minutes + ' minutes ' + remainingSeconds + ' seconds';
      }
    }
  }

  if(state.beacons.waitingTimes == undefined || state.beacons.waitingTimes == null){ return []}

  let newList = [];

  state.beacons.waitingTimes.forEach(object => {
    let time = object.averageWaitingTime;
    let minutes = convertSecondsToMinutes(time);
    let newObject = {
      details:{
        name:object.name, description:object.description, minor: object.minor, major:object.major, beaconId: object.beaconId, uuid: object.uuid
      },
      time: minutes ? minutes : ''
    }
    newList.push(newObject)
  });

  return newList;


};

export const selectWaitingTimesList = (state) => {
  if(state.beacons.waitingTimesList == null || state.beacons.waitingTimesList == undefined || state.beacons.waitingTimesList == []){
    return []
  }

  let list = [];
  let index = 0;

  state.beacons.waitingTimesList.forEach((item) => {
    let newItem = {...item, 'index': index}
    index++;
    list.push(newItem);
  })

  return list;
}

export const selectSubmittedWaitTimes = (state) => {
  if(state.beacons.submittedWaitTimes == null || state.beacons.submittedWaitTimes == undefined || state.beacons.submittedWaitTimes == []){ return []}

  function convertSecondsToTime(seconds) {
    if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
      return 'Invalid input';
    }
  
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.round(seconds % 60);
  
    let formattedTime = '';
  
    if (hours > 0) {
      formattedTime += `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`;
    }
  
    if (minutes > 0) {
      formattedTime += ` ${minutes} ${minutes === 1 ? 'Minute' : 'Minutes'}`;
    }
  
    if (remainingSeconds > 0) {
      formattedTime += ` ${remainingSeconds} ${remainingSeconds === 1 ? 'Second' : 'Seconds'}`;
    }
  
    return formattedTime.trim();
  }

  let tempList = [];
  state.beacons.submittedWaitTimes.forEach((beaconTime) => {
    let cleanedTime = {...beaconTime, elapsedTime: convertSecondsToTime(beaconTime.elapsedTime)}
    tempList.push(cleanedTime);
  })

  // apply date filter
  let dateTempList = [];
  tempList.forEach((beaconTime) => {
    let beacon = new Date(beaconTime.time);
    let startDate = new Date(state.beacons.startDate);
    let endDate = new Date(state.beacons.endDate);

    if (startDate <= beacon && beacon <= endDate) {
      // check if beacon is in selected beacon area
      if(state.beacons.selectBeaconArea == null || state.beacons.selectBeaconArea == 'all-beacons'){
        dateTempList.push(beaconTime)
      } else if(state.beacons.selectBeaconArea != null && state.beacons.selectBeaconArea == beaconTime.beaconId){
        dateTempList.push(beaconTime)
      }
    } else {
        //console.log("Beacon time is outside the start and end dates.");
    }
  });

  return dateTempList;
}

export const selectBeaconWaitingTimes = (state, iata) => {
  if(state.beacons.selectedBeacon == null || state.beacons.selectedBeacon == undefined || state.beacons.selectedBeacon == '' || state.beacons.submittedWaitTimes == []){
    return []
  }

  let tempList = [];
  state.beacons.submittedWaitTimes.forEach((beaconTime) => {
    if(beaconTime.beaconId == state.beacons.selectedBeacon){
      tempList.push(beaconTime);
    }
  });
  
  return tempList;
  
}

export const selectTab = (state) => state.beacons.tab;
export const selectBeaconAreaFilter = (state) => state.beacons.selectedBeaconArea;
export const selectWaitingTimesListStatus = (state) => state.beacons.gettingWaitingTimesListStatus;
export const selectSelectedBeacon = (state) => state.beacons.selectedBeacon;
export const selectWaitingTimesStatus = (state) => state.beacons.status;
export const selectBeaconsPostStatus = (state) => state.beacons.postStatus;
export const selectBeaconsError = (state) => state.beacons.error;
export const { setError, reset, setSelectedBeacon, setEndDate, setStartDate, setBeaconAreaFilter, setTab } = arrivalsSlice.actions;

export default arrivalsSlice.reducer;
